import { render, staticRenderFns } from "./consortia.vue?vue&type=template&id=60a9c518&"
import script from "./consortia.vue?vue&type=script&lang=js&"
export * from "./consortia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports